<template>
  <span id="extension-details-dialog">
    <i
      class="el-icon-search icon-action"
      id="btn-extension-detail-dialog"
      @click="handleOpenDialog"
      size="mini"
      icon="el-icon-plus"
    ></i>
    <el-dialog
      id="dialog-extension-details"
      :close-on-click-modal="false"
      :title="$t('extensionRequest.extensionDetails')"
      :visible.sync="dialogVisible"
      width="60%"
      class="extension-dialog"
    >
      <el-form :model="editForm" :rules="formRules" ref="editForm">
        <el-row :gutter="20">
        <el-col :span="6" class="list-name">
          <label class="margin-bottom-small-list">{{ $t('extensionRequest.extensionHash') }}</label>
        </el-col>
        <el-col :span="6" class="list-name">
          <span class="span-small-list">{{ extensionRequest.headerUnitList.number }}</span>
        </el-col>
        <el-col :span="6" class="list-name">
          <label class="margin-bottom-small-list">{{ $t('extensionRequest.status') }}</label>
        </el-col>
        <el-col :span="6" class="list-name">
          <span
           class="span-small-list"
         >{{extensionRequest.headerUnitList.status === 0 ? $t('extensionRequest.pending'):extensionRequest.headerUnitList.status === 1? $t('extensionRequest.approved') : $t('extensionRequest.rejected')}}</span>
        </el-col>
      </el-row>

        <el-row :gutter="20">
          <el-col :span="6" class="list-name">
            <label class="margin-bottom-small-list">{{
              $t('extensionRequest.receivingDate')
            }}</label>
          </el-col>
          <el-col :span="6" class="list-name">
            <span class="span-small-list">{{ shipDate }}</span>
          </el-col>
          <el-col :span="6" class="list-name">
            <label class="margin-bottom-small-list">{{
              $t('extensionRequest.shippingHour')
            }}</label>
          </el-col>
          <el-col :span="6" class="list-name">
            <span class="span-small-list" v-if="!extensionRequest.isEditingRow">
              {{ formatHour }}
              <i
                v-if='extensionRequest.headerUnitList.status != extensionsStatusOptions[2].value'
                class="el-icon-edit icon-action"
                @click="handleEdit(extensionRequest)"
              ></i>
            </span>
            <span lass="span-small-list" v-else>
              <el-form-item prop="shippingHour">
                <el-time-select
                  clearable
                  class="inline-input"
                  size="mini"
                  style="width: 70%"
                  v-model="editForm.shippingHour"
                  :picker-options="datePickerHourOptions"
                >
                </el-time-select>
                <el-button
                  icon="el-icon-success"
                  circle
                  size="mini"
                  @click="updateShippingHour()"
                ></el-button>
                <el-button
                  icon="el-icon-circle-close"
                  circle
                  size="mini"
                  @click="cancelEdit(extensionRequest)"
                ></el-button>
              </el-form-item>
            </span>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6" class="list-name">
            <label class="margin-bottom-small-list">{{
              $t('extensionRequest.shipper')
            }}</label>
          </el-col>
          <el-col :span="18" class="list-name">
            <span class="span-small-list">
              {{ extensionRequest.headerUnitList.shipperAccountName }} - {{ extensionRequest.headerUnitList.shipperAccountNumber }}
            </span>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6" class="list-name">
            <label class="margin-bottom-small-list">{{
              $t('extensionRequest.applicantName')
            }}</label>
          </el-col>
          <el-col :span="18" class="list-name">
            <span class="span-small-list">{{
              extensionRequest.headerUnitList.applicantName
            }}</span>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6" class="list-name">
            <label class="margin-bottom-small-list">{{
              $t('extensionRequest.email')
            }}</label>
          </el-col>
          <el-col :span="18" class="list-name">
            <span class="span-small-list">{{
              extensionRequest.headerUnitList.email
            }}</span>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6" class="list-name">
            <label class="margin-bottom-small-list">{{
              $t('extensionRequest.shipperContact')
            }}</label>
          </el-col>
          <el-col :span="18" class="list-name">
            <span class="span-small-list">{{
              extensionRequest.headerUnitList.contactNumber
            }}</span>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6" class="list-name">
            <label class="margin-bottom-small-list">{{
              $t('extensionRequest.notes')
            }}</label>
          </el-col>
          <el-col :span="18">
            <span class="span-small-list scroll-div">{{
              extensionRequest.headerUnitList.notes
            }}</span>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6" class="list-name">
            <label class="margin-bottom-small-list">{{
              $t('extensionRequest.boxes')
            }}</label>
          </el-col>
          <el-col :span="18" class="list-name">
            <span class="span-small-list">{{
              extensionRequest.headerUnitList.numberUnits
            }}</span>
          </el-col>
        </el-row>
      </el-form>
      <span class="shipment-table el-dialog__title">{{
        $t('extensionRequest.shipmentDetails')
      }}</span>
      <el-table
        stripe
        size="mini"
        tooltip-effect="dark"
        sortable
        width="80%"
        class="dark-blue-table"
        v-loading="extensionRequest.loadingDetails"
        :empty-text="$t('common.notAbleToFindRecords')"
        :data="extensionRequest.searchUnitResponse.data"
      >
        <el-table-column
          align="left"
          header-align="center"
          prop="Consignee"
          :label="$t('extensionRequest.consignee')"
        >
          <template slot-scope="scope">
            <span class="font-size-14px">{{
              scope.row.consigneeAccountName
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="city"
          :label="$t('extensionRequest.city')"
        >
          <template slot-scope="scope">
            <span class="font-size-14px">{{
              scope.row.consigneeCity
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="state"
          :label="$t('extensionRequest.state')"
        >
          <template slot-scope="scope">
            <span class="font-size-14px">{{
              scope.row.consigneeState
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="Dimensions"
          :label="$t('extensionRequest.dimensions')"
        >
          <template slot-scope="scope">
            <span class="font-size-14px"
              >{{ scope.row.length }}x{{ scope.row.width }}x{{
                scope.row.height
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="Units"
          :label="$t('extensionRequest.units')"
        >
          <template slot-scope="scope">
            <span class="font-size-14px">{{ scope.row.numberUnits }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="text-align-center"
        @size-change="handleSearchChangeLimit"
        @current-change="handleSearchChangePage"
        :page-sizes="sizes"
        :page-size="extensionRequest.actualFiltersUnits.rows"
        :current-page.sync="extensionRequest.actualFiltersUnits.page"
        layout="total, sizes, prev, pager, next, jumper"
        :total="extensionRequest.searchUnitResponse.totalRows"
      ></el-pagination>

      <span slot="footer" class="dialog-footer footer-btn">
        <reject-dialog-button
          v-if="
            extensionRequest.headerUnitList.status === extensionsStatusOptions[1].value ||
              extensionRequest.headerUnitList.status === extensionsStatusOptions[2].value
          "
          @closeDialog="dialogVisible = false"
          :shipDate="shipDate"
        />
        <el-button
          id="form-approve-button"
          type="primary"
          @click="handleApprove"
          class="approved-btn"
          v-if="extensionRequest.headerUnitList.status === extensionsStatusOptions[1].value"
        >
          <img src="@/assets/svg/Approved-Logo.svg" alt="Approved-Logo" />
          {{ $t("extensionRequest.approve") }}
        </el-button>
      </span>
    </el-dialog>
  </span>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import RejectDialogButton from './RejectDialog';

const extensionRequestSearchAction = 'extensionRequest/search';
const extensionRequestSetEditingRowAction = 'extensionRequest/setEditingRow';
const extensionRequestFindUnitsAction = 'extensionRequest/findUnits';

export default {
  computed: {
    ...mapGetters(['extensionRequest']),
    formatHour() {
      return moment(this.extensionRequest.headerUnitList.shippingHour, [
        moment.ISO_8601,
        'HH:mm'
      ]).format('HH:mm');
    }
  },
  props: {
    extensionNo: {
      type: String,
      default: null
    },
    shipDate: {
      type: String,
      default: null
    }
  },
  components: {
    RejectDialogButton
  },
  data() {
    const validHoursChange = (rule, value, callback) => {
      const currentHour = moment();
      const cutOffHour = moment(
        this.extensionRequest.headerUnitList.shippingHour,
        'HH:mm:ss'
      );
      cutOffHour.subtract(
        constants.ORDER_ENTRY.EXTENSION.MINUTE_BEFORE_CHANGE,
        'minutes'
      );
      if (currentHour.isAfter(cutOffHour)) {
        callback(new Error(this.$t('extensionRequest.hoursValid')));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      datePickerHourOptions: {
        step: '00:15',
        end: '23:59'
      },
      editForm: {
        number: '',
        shippingHour: ''
      },
      formRules: {
        shippingHour: [
          {
            required: true,
            message: this.$t('warehouse.orderEntry.error.hourRequired'),
            trigger: 'blur'
          },
          { validator: validHoursChange, trigger: 'blur' }
        ]
      },
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES,
      extensionsStatusOptions: constants.EXTENSION_REQUEST.EXTENSIONS_STATUS
    };
  },
  methods: {
    handleClose(done) {
      this.$store.dispatch(extensionRequestSearchAction, {});
      done();
    },
    handleOpenDialog() {
      this.clearEdit();
      this.dialogVisible = true;
      this.findExtensionsByShipper();
    },
    handleEdit(row) {
      this.editForm.number = row.headerUnitList.number;
      this.editForm.shippingHour = moment(row.headerUnitList.shippingHour, [
        moment.ISO_8601,
        'HH:mm'
      ]).format('HH:mm');
      this.$store.dispatch(extensionRequestSetEditingRowAction, true);
      row.edit = true;
    },
    clearEdit() {
      this.$store.dispatch(extensionRequestSetEditingRowAction, false);
    },
    cancelEdit(row) {
      this.$store.dispatch(extensionRequestSetEditingRowAction, false);
      row.edit = false;
    },
    updateShippingHour() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.$store
            .dispatch('extensionRequest/updateShippingHour', {
              extensionNo: this.editForm.number,
              shippingHour: this.editForm.shippingHour
            })
            .then((response) => {
              loading.close();
              this.clearEdit();
              this.$message.success(response.message);
              this.findExtensionsByShipper();
              this.$store.dispatch(extensionRequestSearchAction, {});
            })
            .catch(() => {
              loading.close();
            });
        }
      });
    },
    findExtensionsByShipper() {
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      return this.$store
        .dispatch(extensionRequestFindUnitsAction, {
          extensionNo: this.extensionNo,
          page: constants.TABLES.DEFAULT_PAGE
        })
        .then(() => {
          loading.close();
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
          loading.close();
        });
    },
    handleSearchChangePage(val) {
      this.$store.dispatch(extensionRequestFindUnitsAction, { page: val });
    },
    handleSearchChangeLimit(val) {
      this.$store.dispatch(extensionRequestFindUnitsAction, {
        rows: val,
        page: constants.TABLES.DEFAULT_PAGE
      });
    },
    async handleApprove() {
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      try {
        const response = await this.$store.dispatch(
          'extensionRequest/approve',
          this.shipDate
        );
        this.$message.success(response.message);
      } finally {
        await this.$store.dispatch(extensionRequestSearchAction, {});
        loading.close();
        this.dialogVisible = false;
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.extension-dialog {
  .shipment-table {
    color: #01355f;
    float: left;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  .el-dialog {
    width: 400px;
    font-family: Open Sans, Helvetica Neue, Helvetica, PingFang SC,
      Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  }
  .scroll-div {
    overflow-y: auto;
    white-space: normal;
    text-overflow: unset;
    max-width: 500px;
    max-height: 43px;
  }
  .detail-wrp {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
    .ex-button {
      width: 30%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .ex-button-wrp {
        display: inline-flex;
        flex-direction: column;
        span {
          font-size: 11px;
        }
        .pending-btn {
          padding: 9px 0;
          background: #fff5de;
          color: #d19d4c;
          border: 1px solid #d19d4c;
          font-size: 11px;
          width: 100px;
          margin-left: 12px;
          display: flex;
          span {
            display: flex;
            align-items: center;
            font-size: 14px;
            margin-left: 15px;
          }
          img {
            height: 13px;
            margin-right: 14px;
          }
        }
      }
    }
    .ex-detail {
      width: 70%;
      border-right: 3px solid #01355f;
      p {
        font-size: 14px;
        text-align: left;
        margin: 0;
      }
    }
  }
  .footer-btn {
    &.footer-wrp {
      display: block;
      margin-top: 15px !important;
    }
    .deny-btn,
    .approved-btn {
      padding: 9px 0;
      background: #ffd7d8;
      color: #a32327;
      border: 1px solid #a32327;
      font-size: 11px;
      width: 100px;
      display: inline-flex;
      margin-left: 15px !important;
      span {
        display: flex;
        align-items: center;
        font-size: 11px;
        margin: auto;
      }
      img {
        height: 13px;
        margin-right: 7px;
      }
    }
    .approved-btn {
      background: #d8ecda;
      color: #52ac64;
      border: 1px solid #52ac64;
    }
  }

  .el-form-item__content {
    .el-date-editor {
      input.el-input__inner {
        padding-left: 30px;
      }
    }
  }
}
@media only screen and (max-width: 992px) {
  .extension-dialog .el-dialog {
    width: 500px;
  }
  .list-name {
    width: 50%;
  }
}
@media only screen and (max-width: 480px) {
  .extension-dialog {
    .el-dialog {
      width: auto;
      margin: 0 15px;
    }
  }
  .list-name {
    .margin-bottom-small-list,
    .span-small-list {
      font-size: 8px;
    }
  }
}
</style>
